import React, { forwardRef } from "react";
import SelectOption from "../../../../../../components/SelectOption";
import { useApi } from "../../../../../../hooks/http2";
import { URL_API, _ } from "../../../../../../utils";

const SelectDepartments = ({ division_id, ...props }) => {
  const list = useApi(
    {
      url: `${URL_API}/setting/master/departments`,
      token: true,
      params: { division_id },
    },
    [division_id]
  );

  return (
    <SelectOption
      loading={list.loading}
      data={_.map(list.fetch?.data || [], (n) => ({
        value: n.id,
        text: n.name_local,
      }))}
      withAll
      allText={
        (list.fetch?.data || []).length > 0 ? "เลือกแผนก" : "-- ไม่มีข้อมูล --"
      }
      {...props}
    />
  );
};

export default forwardRef((props, ref) => {
  return <SelectDepartments forwardRef={ref} {...props} />;
});
